import { IPresentableEntity } from '@/models/available-entities.interface';
import { PremiumLevels } from '@studyportals/campaign-management-api-interface';

class EntityPremiumnessPresenter {

	public getFullName(entity: IPresentableEntity): string {
		switch (entity.status) {
			case PremiumLevels.PREMIUM:
				return 'Premium';
			case PremiumLevels.SUPER_PREMIUM:
				return 'Super Premium';
			case PremiumLevels.LIGHT_PREMIUM:
				return 'Light Premium';
			case PremiumLevels.GEOTARGETED:
				return 'Geotargeted';
			case PremiumLevels.BASIC:
				return 'Basic'
			default:
				throw Error(`EntityPremiumnessPresenter.getFullName: invalid status: ${entity.status as string}`);
		}
	}

	public getAbbreviatedName(entity: IPresentableEntity): string {
		switch (entity.status) {
			case PremiumLevels.PREMIUM:
				return 'P';
			case PremiumLevels.SUPER_PREMIUM:
				return 'SP';
			case PremiumLevels.LIGHT_PREMIUM:
				return 'LP';
			case PremiumLevels.GEOTARGETED:
				return 'G';
			case PremiumLevels.BASIC:
				return 'B'
			default:
				throw Error(`EntityPremiumnessPresenter.getAbbreviatedName: invalid status: ${entity.status as string}`);
		}
	}

	public getStylingClassName(entity: IPresentableEntity): string {
		switch (entity.status) {
			case PremiumLevels.PREMIUM:
				return 'EntityPremiumnessIndicatorPremium';
			case PremiumLevels.SUPER_PREMIUM:
				return 'EntityPremiumnessIndicatorSuperPremium';
			case PremiumLevels.LIGHT_PREMIUM:
				return 'EntityPremiumnessIndicatorLightPremium';
			case PremiumLevels.GEOTARGETED:
				return 'EntityPremiumnessIndicatorGeotargeted';
			case PremiumLevels.BASIC:
				return 'EntityPremiumnessIndicatorBasic'
			default:
				throw Error(`EntityPremiumnessPresenter.getStylingClassName: invalid status: ${entity.status as string}`);
		}
	}
}

export default new EntityPremiumnessPresenter();
